
export const selectMenu = (parameter) => {  
    return { 
        type : 'SELECTMENU',
        parm : parameter
    }
}


export const fullSize = (parameter) => {  
    return { 
        type : 'FULLSIZE',
        parm : parameter
    }
}


export const getRefresh = (parameter) => { 
    return { 
        type : 'GETREFRESH',
        parm : parameter
    }    
}



 export const logUser = (parameter) => { 
    return { 
        type : 'LOGUSER',
        parm : parameter
     }
}
 export const setisjoin = (parameter) => { 
    return { 
        type : 'SETISJOIN',
        parm : parameter
     }
}
 export const setupdtoken = (parameter) => { 
    return { 
        type : 'SETUPDTOKEN',
        parm : parameter
     }
}
 export const setupdtoken2 = (parameter) => { 
    return { 
        type : 'SETUPDTOKEN2',
        parm : parameter
     }
}
 export const setaucid = (parameter) => { 
    return { 
        type : 'SETAUCID',
        parm : parameter
     }
}
 export const setisfirsttime = (parameter) => { 
    return { 
        type : 'SETISFIRSTTIME',
        parm : parameter
     }
}


export const teamlistData = (parameter) => { 
    return { 
        type : 'TEAMLIST',
        parm : parameter
    }    
}

export const catlistData = (parameter) => { 
    return { 
        type : 'CATLIST',
        parm : parameter
    }    
}
export const playerlistData = (parameter) => { 
    return { 
        type : 'PLAYERLIST',
        parm : parameter
    }    
}
export const playerfilter = (parameter) => { 
    return { 
        type : 'PLAYERFILTER',
        parm : parameter
    }    
}

export const actlistData = (parameter) => { 
    return { 
        type : 'ACTLIST',
        parm : parameter
    }    
}
export const actmore = (parameter) => { 
    return { 
        type : 'ACTMORE',
        parm : parameter
    }    
}


export const upcomingActlistData = (parameter) => { 
    return { 
        type : 'UPCOMING_AUCTION',
        parm : parameter
    }    
}


export const todayAuction = (parameter) => { 
    return { 
        type : 'TODAY_AUCTION',
        parm : parameter
    }    
}


export const joinAuction = (parameter) => { 
    return { 
        type : 'JOIN_AUCTION',
        parm : parameter
    }    
}

